import { ImageNotSupported } from "@mui/icons-material";
import clsx from "clsx";
import { FC } from "react";

import useStyles from "./MediaErrorPlaceholder.styles";


export interface MediaErrorPlaceholderProps {
    className?: string;
}

const MediaErrorPlaceholder: FC<MediaErrorPlaceholderProps> = ({ className }) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.container, className)}>
            <div className={classes.iconSpace}>
                <ImageNotSupported className={classes.icon}/>
            </div>
        </div>
    );
};

export default MediaErrorPlaceholder;
